import type { DeliveryZoneModeAssignmentsResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDeliveryZoneModeAssignments = (
  options?: ApiV2QueryOptions<DeliveryZoneModeAssignmentsResponseType>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  return useQuery({
    queryKey: [business?.id, ServerStateKeys.DeliveryZoneModeAssignments],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "delivery-zones/mode/assignments",
      }).then(
        (response) =>
          apiV2AssertResponse<DeliveryZoneModeAssignmentsResponseType>(response)
            .data,
      ),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business },
      options,
    }),
  });
};
